import Input from './Input';
import TextArea from './TextArea';
import Select from './Select';
import Radio from './Radio';
import CheckBox from './CheckBox';
import DatePicker from './DatePicker';
import SubmitButton from './SubmitButton';
// import UploadImage from './UploadImage';
import NotEditableItem from './NotEditableItem';
import Autocomplete from './Autocomplete';

export {
  Input,
  TextArea,
  Select,
  Radio,
  CheckBox,
  DatePicker,
  SubmitButton,
  // UploadImage,
  NotEditableItem,
  Autocomplete,
};



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/index.js